import React, {useEffect, useRef, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    CCText,
    FlatList,
    Text,
    TextInput,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import AppConfig from '../../../AppConfig';

import TFoodScreen from './Translations/TFoodScreen';
import FoodItem from '../../../components/admin/Food/FoodItem';

import {ThemeButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import ActivityIndicatorWrapper from '../../../components/public/UI/ActivityIndicatorWrapper';
import {useSelector} from 'react-redux';
import NewFoodModal from "../../../components/admin/Food/NewFoodModal";
import {useNavigate} from "react-router-dom";

const FoodScreen = (props) => {
    const navigate = useNavigate();
    const searchRef = useRef(null);
    const timerRef = useRef(null);
    const auth = useSelector(state => state.Auth);

    const limit = 10;
    let stopFetching = false;
    let currentlyFetching = false;

    let [offset, setOffset] = useState(0);
    const [filterActive, setFilterActive] = useState(true);
    const [hideLoadButton, setHideLoadButton] = useState(false);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [food, setFood] = useState([]);
    const [isNewFoodModalOpen, setIsNewFoodModalOpen] = useState(false);

    const toggleNewFoodModal = () => {
        setIsNewFoodModalOpen(!isNewFoodModalOpen);
    }

    const fetchData = async (targetOffset) => {
        try {
            if (currentlyFetching)
                return;

            if (!stopFetching) {
                currentlyFetching = true;

                if (targetOffset == 0)
                    setFood([]);

                setLoading(true);

                const response = await fetch(AppConfig.URL + '/Food/Index/?Search=' + search + '&Offset=' + targetOffset + '&Limit=' + limit + "&Active=" + filterActive, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': auth.token
                        },
                    }
                );

                let data = await response.json();

                if (data.food.length < limit) {
                    stopFetching = true;
                    setHideLoadButton(true);
                }

                let allFood = [...food];

                if (targetOffset == 0) {
                    allFood = data.food;
                } else {
                    allFood = allFood.concat(data.food);
                }

                setLoading(false);
                setFood(allFood);
                setOffset(targetOffset + limit);

                currentlyFetching = false;
            }
        } catch (error) {
            console.log(error);

            setLoading(false);
            currentlyFetching = false;
        }
    }

    useEffect(() => {
        if (!search)
            return;

        if (timerRef.current)
            clearTimeout(timerRef.current);

        timerRef.current = setTimeout(async () => {
            fetchData(0);
        }, 250);
    }, [search])

    useEffect(() => {
        fetchData(0);
    }, [filterActive])

    useEffect(() => {
        fetchData(0);
    }, [])

    return <View style={{}}>
        <View
            style={{flexDirection: 'row', justifyContent: 'space-between'}}
        >
            <h1>
                {TFoodScreen[AppConfig.lang].FOOD}
            </h1>
            <ThemeButton
                text={TFoodScreen[AppConfig.lang].NEW_FOOD}
                onPress={toggleNewFoodModal}
            />
        </View>
        <View className="row">
            <View className="col-12 col-md-9" style={{flexDirection: 'row', marginBottom: 15}}>
                <View>
                    <CCText className="chocoform-select-label">
                        {TFoodScreen[AppConfig.lang].SHOW}
                    </CCText>
                    <select
                        onChange={(event) => {
                            setFilterActive(event.target.value == "true")
                            stopFetching = false
                        }}
                        className="chocoform-select"
                    >
                        <option value={true}>{TFoodScreen[AppConfig.lang].ACTIVE}</option>
                        <option value={false}>{TFoodScreen[AppConfig.lang].INACTIVE}</option>
                    </select>
                </View>
                <View style={{position: 'relative', marginLeft: 15}}>
                    <TextInput
                        ref={searchRef}
                        value={search}
                        placeholder={TFoodScreen[AppConfig.lang].SEARCH}
                        onChangeText={(text) => {
                            stopFetching = false
                            setSearch(text)
                        }}
                    />
                    <Text
                        onPress={() => {
                            if (searchRef) searchRef.current.focus()
                        }}
                        className={"chocoform-label"}
                    >
                        {TFoodScreen[AppConfig.lang].SEARCH}
                    </Text>
                </View>
            </View>
        </View>
        <View
            className={'card-desktop'}
        >
            <View
                className={'card-body'}
                style={{
                    paddingTop: 0, paddingBottom: 0
                }}
            >
                <View className="hide-mobile">
                    <View className="row">
                        <View className="col-2 col-md-1 th">
                            <CCText style={{fontWeight: 'bold'}}>
                                {TFoodScreen[AppConfig.lang].IMAGE}
                            </CCText>
                        </View>
                        <View className="col-12 col-md-2 th">
                            <CCText style={{fontWeight: 'bold'}}>
                                {TFoodScreen[AppConfig.lang].NAME}
                            </CCText>
                        </View>
                        <View className="col-12 col-md-1 th">
                            <CCText style={{fontWeight: 'bold'}}>
                                {TFoodScreen[AppConfig.lang].PRICE}
                            </CCText>
                        </View>
                        <View className="col-12 col-md-4 th">
                            <CCText style={{fontWeight: 'bold'}}>
                                {TFoodScreen[AppConfig.lang].DESC}
                            </CCText>
                        </View>
                        <View className="col-12 col-md-4 th" style={{}}>

                        </View>
                    </View>
                </View>
                <FlatList
                    keyboardShouldPersistTaps={'always'}
                    maxToRenderPerBatch={8}
                    windowSize={15}
                    keyExtractor={item => {
                        return item.foo_id;
                    }}
                    data={food}
                    renderItem={({item}) => <View>
                        <FoodItem
                            item={item}
                            Auth={auth}
                        />
                    </View>}
                    ListFooterComponent={() => {
                        let Component = null;

                        if (loading) {
                            Component = <ActivityIndicatorWrapper
                                style={{marginTop: 20, marginBottom: 30}}
                            />;
                        } else {
                            Component = <View
                                style={{
                                    marginTop: 20,
                                    marginBottom: 30,
                                    flexDirection: 'row',
                                    justifyContent: 'center'
                                }}
                            >
                                {!hideLoadButton ?
                                    <ThemeButton
                                        text={TFoodScreen[AppConfig.lang].LOAD_MORE}
                                        onPress={() => {
                                            fetchData(offset)
                                        }}
                                    />
                                    :
                                    null
                                }
                            </View>
                        }

                        return Component;
                    }}
                />
            </View>
        </View>
        <NewFoodModal
            visible={isNewFoodModalOpen}
            onRequestClose={toggleNewFoodModal}
            callback={(newFood) => {
                const allFood = [...food];

                newFood.openEditor = true;

                allFood.push(newFood)

                setFood(allFood)
                toggleNewFoodModal();
            }}
        />
    </View>
}

export default FoodScreen;